// extracted by mini-css-extract-plugin
module.exports = {"label":"tight-progress-bar_label__2oFFr","bar":"tight-progress-bar_bar__1N9bH"};